import { TranslationKey, useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Checkbox } from '../../../../design/inputs/checkbox/S_Checkbox';
import { S_FieldLabel } from '../../../../design/labels/fieldLabel/S_FIeldLabel';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { handleCheck, handleNumberChange } from '../../../helpers/formHelpers';
import { InputStatus } from '../../../models/error.model';

const UNLIMITED = -1;

interface INumericInputWithToggle {
  disabled?: boolean;
  name: TranslationKey;
  value?: number;
  default?: number;
  checked: boolean;
  inputStatus: InputStatus;
  onValueChange: (value?: number) => void;
  onToggle: (value: boolean) => void;
  onBlur: () => void;
}

export const NumericInputWithToggle = observer((props: INumericInputWithToggle): ReactElement => {
  const { t } = useTranslator();
  return (
    <div>
      <S_FieldLabel text={t(props.name)} />
      <div className='numeric-input-with-toggle'>
        <ValidatedTextInput
          type='text'
          id={`${props.name}-input`}
          min={1}
          value={props.value && props.value !== UNLIMITED ? props.value : ''}
          isValid={props.value && props.value === UNLIMITED ? undefined : props.inputStatus.isValid}
          onChange={handleNumberChange(props.onValueChange)}
          disabled={props.disabled || props.value === UNLIMITED}
          feedbacks={props.inputStatus.errorCodes}
          onBlur={props.onBlur}
          className={props.disabled ? 'disabled-input' : ''}
          defaultValue={props.default}
        />
        <S_Checkbox
          id={`${props.name}-unlimited-checkbox`}
          checked={props.checked}
          onChange={handleCheck(props.onToggle)}
          label={t('unlimited')}
          disabled={props.disabled}
          className='unlimited'
        />
      </div>
    </div>
  );
});
